import { render, staticRenderFns } from "./steps-bar.vue?vue&type=template&id=22babfe4&scoped=true"
import script from "./steps-bar.vue?vue&type=script&lang=js"
export * from "./steps-bar.vue?vue&type=script&lang=js"
import style0 from "./steps-bar.vue?vue&type=style&index=0&id=22babfe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22babfe4",
  null
  
)

export default component.exports